module.exports = __webpack_public_path__ + "img/Stemness-OPSCC_PMID37704757.298ed902.png";